<nb-card class="dialog-card">
  <nb-card-header>Detalhes — {{ pessoa.nome || 'Pessoa' }}</nb-card-header>
  <nb-card-body>
    <div class="loading-wrap" *ngIf="carregando">
      <nb-spinner status="primary" size="medium"></nb-spinner>
      <span>Carregando…</span>
    </div>

    <ng-container *ngIf="!carregando">
      <section class="secao">
        <h4 class="secao-titulo">Turmas (matrículas)</h4>
        <p class="secao-erro" *ngIf="erroTurmas">{{ erroTurmas }}</p>
        <div class="table-wrap" *ngIf="turmas.length && !erroTurmas">
          <table class="detalhes-table">
            <thead>
              <tr>
                <th>Turma</th>
                <th>Frequência em missa</th>
                <th>Matrícula desde</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let t of turmas; trackBy: trackByTurma">
                <td>
                  <a
                    *ngIf="t.turmaId?.trim(); else turmaNomeSemLink"
                    class="turma-detalhes-link"
                    href="#"
                    (click)="abrirDetalhesTurma(t, $event)"
                    title="Abrir detalhes da turma"
                  >
                    {{ t.turmaNome || '—' }}
                  </a>
                  <ng-template #turmaNomeSemLink>{{ t.turmaNome || '—' }}</ng-template>
                </td>
                <td>{{ simNao(t.frequenciaMissa) }}</td>
                <td>
                  <ng-container *ngIf="t.dataInclusao; else semData">{{
                    t.dataInclusao | date: 'dd/MM/yyyy HH:mm'
                  }}</ng-container>
                  <ng-template #semData>—</ng-template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="secao-vazio" *ngIf="!turmas.length && !erroTurmas">Nenhuma turma matriculada.</p>
      </section>

      <section class="secao">
        <h4 class="secao-titulo">Integração Theos</h4>
        <p class="secao-erro" *ngIf="erroTheos && !theos">{{ erroTheos }}</p>
        <dl class="dl-theos" *ngIf="theos as th">
          <div class="dl-row">
            <dt>Código Theos</dt>
            <dd>{{ th.codigoTheos != null ? th.codigoTheos : '—' }}</dd>
          </div>
          <div class="dl-row">
            <dt>Catequizando</dt>
            <dd>{{ simNao(th.catequizando) }}</dd>
          </div>
          <div class="dl-row">
            <dt>Código catequizando</dt>
            <dd>{{ th.catequizandoCodigo != null ? th.catequizandoCodigo : '—' }}</dd>
          </div>
          <div class="dl-row">
            <dt>Dizimista</dt>
            <dd>{{ simNao(th.dizimista) }}</dd>
          </div>
          <div class="dl-row">
            <dt>ID dizimista (Theos)</dt>
            <dd>{{ th.dizimistaId?.trim() ? th.dizimistaId : '—' }}</dd>
          </div>
          <div class="dl-row">
            <dt>Data cadastro (Theos)</dt>
            <dd>{{ th.dataCadastro?.trim() ? th.dataCadastro : '—' }}</dd>
          </div>
        </dl>
      </section>
    </ng-container>
  </nb-card-body>
  <nb-card-footer class="footer-actions">
    <button nbButton status="primary" type="button" size="medium" (click)="fechar()">Fechar</button>
  </nb-card-footer>
</nb-card>
